import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { SHOW_DEBUG_PANELS } from 'config';
import { useSelector } from 'reduxState/storeCore';

const WrapMain = styled.div<{
  $fixedBottomRight: boolean;
  $bottomMargin?: number;
}>`
  color: yellow;
  opacity: 0.5;
  ${({ $fixedBottomRight }) =>
    $fixedBottomRight
      ? 'position: fixed; right: 12px; bottom: 12px;'
      : `
  position: absolute;
  bottom: 20px;
  right: 10px;
  left: 10px;
    `}
  ${({ $bottomMargin }) =>
    $bottomMargin && `margin-bottom: ${$bottomMargin}px;`}
`;

export function DebugPanel({
  children,
  fixedBottomRight = false,
  bottomMargin,
  desktopOnly = false,
}: {
  children: ReactNode;
  fixedBottomRight?: boolean;
  bottomMargin?: number;
  desktopOnly?: boolean;
}) {
  const isMobile = useSelector(state => state.screen.isMobile);

  if (!SHOW_DEBUG_PANELS) {
    return null;
  }

  if (desktopOnly && isMobile) {
    return null;
  }

  return (
    <WrapMain $fixedBottomRight={fixedBottomRight} $bottomMargin={bottomMargin}>
      <b>DEBUG:</b>
      <br />
      {children}
    </WrapMain>
  );
}
